import {
  formatMomentDate,
  getCurrentDate,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import { ProfileReservation, DownArrowIcon } from '@assets/icons/';
import CustomIcon from '@components/utils/CustomIcon';
import SingleDatePicker from '@components/DatePicker/SingleDatePicker/SingleDatePicker';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

import SearchBarInput from '../../SearchBarInput';
import { SearchBarSingleDatePickerInputProps } from './SearchBarSingleDatePickerInputInterface';

const SearchBarSingleDatePickerInput = ({
  dateProps: { date, onDateChange, ...otherDateProps },
  popoverProps: { onVisibleChange, ...otherPopoverProps } = {},
  error,
  setButtonDisable,
  ...otherProps
}: SearchBarSingleDatePickerInputProps) => {
  const dateString = formatMomentDate(date);
  useSkipEffectOnMount(() => {
    setButtonDisable?.(true);
  }, [dateString]);
  return (
    <SearchBarInput
      leftIcon={() => (
        <CustomIcon
          fontSize={28}
          paletteColor='coral'
          icon={ProfileReservation}
        />
      )}
      rightIcon={() => (
        <CustomIcon
          icon={DownArrowIcon}
          fontSize={16}
          paletteColor='darkGray'
        />
      )}
      error={error}
      isFilled={dateString.length > 0}
      InputComponent={dateString || otherProps.placeholder}
      popoverProps={{
        onVisibleChange,
        ...otherPopoverProps,
      }}
      renderOverlayContent={(closePopup) => {
        return (
          <SingleDatePicker
            onDateChange={(date) => {
              onDateChange(date);
              closePopup();
            }}
            isOutsideRange={(day) =>
              !isInclusivelyAfterDay(day, getCurrentDate())
            }
            initialVisibleMonth={null}
            date={date}
            {...otherDateProps}
          />
        );
      }}
      {...otherProps}
    />
  );
};

export default SearchBarSingleDatePickerInput;
